import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

import playgroundImage from './playground@large.jpg';
import classroomImage from './classroom2@large.jpg';
import musicImage from './music@large.jpg';

const tabs = ['Classrooms', 'Playground', 'Arts Rooms'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="learning-spaces-kis">
        <h1>Primary School Learning Spaces</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              The classrooms throughout Kingston are evolving spaces, in which teachers and students negotiate the best
              possible learning environments to facilitate learning. No two classrooms are identical, which ensures that
              the needs of the individual learners inside are met. Many breakout spaces exist around our campuses in
              order to allow students to work both collaboratively and individually in spaces outside our classrooms.
            </p>
            <p>
              As the nature of our program has evolved, so have our spaces in order to meet the needs of our learners.
              You will find the different areas around the school to incorporate flexible seating alternatives for
              students as well as state of the art furniture, which can be manipulated in order to cater to the type of
              learning happening at any given time. Staff are encouraged to continue to rethink spaces in order to
              reflect the inquiry based learning taking place across our community.
            </p>
            <img src={classroomImage} alt="Classroom at KIS" />
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              Both our Upper and Lower Primary campuses are equipped with outdoor multi-purpose playgrounds for various
              uses. Physical Education class is conducted on our playgrounds along with recesses, extra curricular
              activities and school wide events. When available, teachers make use of these spaces to utilize the larger
              spaces for learning engagements.
            </p>
            <img src={playgroundImage} alt="KIS Playground" />
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <p>
              Our Arts rooms have been designed by our very talented Music and Design & Drama teachers. These rooms are
              equipped with flexible seating to be able to adapt to the lesson needs of these teachers.
            </p>
            <img src={musicImage} alt="Child playing an instrument" />
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
